'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _date_formatter = require('../../../packages/common-utilities/src/date_formatter.js');

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _string_utility = require('../../../packages/common-utilities/src/string_utility.js');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _ramda = require('ramda');

var _accessibility_utility = require('../../../packages/common-utilities/src/accessibility_utility');

var _accessibility_utility2 = _interopRequireDefault(_accessibility_utility);

var _functional_utility = require('../../../packages/common-utilities/src/functional_utility');

var _collection_utility = require('../../../packages/common-utilities/src/collection_utility');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapIndexed = (0, _ramda.addIndex)(_ramda.map);

var SummaryHeaderPerformanceRatings = function (_React$Component) {
  _inherits(SummaryHeaderPerformanceRatings, _React$Component);

  function SummaryHeaderPerformanceRatings(props) {
    _classCallCheck(this, SummaryHeaderPerformanceRatings);

    var _this = _possibleConstructorReturn(this, (SummaryHeaderPerformanceRatings.__proto__ || Object.getPrototypeOf(SummaryHeaderPerformanceRatings)).call(this, props));

    _this.renderFundRatings = _this.renderFundRatings.bind(_this);
    _this.renderPerformanceRating = _this.renderPerformanceRating.bind(_this);
    _this.handleDisclosureIconClick = _this.handleDisclosureIconClick.bind(_this);
    return _this;
  }

  _createClass(SummaryHeaderPerformanceRatings, [{
    key: 'renderFundRatings',
    value: function renderFundRatings() {
      var _this2 = this;

      if ((0, _ramda.isNil)(this.props.fundPerformanceRatings)) {
        return null;
      }
      return mapIndexed(function (fundPerformanceRating, index) {

        if (index < _this2.props.numberOfItemsToShow) {
          return _this2.renderPerformanceRating(fundPerformanceRating, index);
        }
      }, this.props.fundPerformanceRatings);
    }
  }, {
    key: 'renderFundRatingsAsOfDates',
    value: function renderFundRatingsAsOfDates() {
      var _this3 = this;

      if ((0, _ramda.isNil)(this.props.fundPerformanceRatings)) {
        return null;
      }

      return mapIndexed(function (fundPerformanceRating, index) {

        if (index < _this3.props.numberOfItemsToShow) {
          return _this3.renderPerformanceRatingAsOfDates(fundPerformanceRating, index);
        }
      }, this.props.fundPerformanceRatings);
    }
  }, {
    key: 'getIconEl',
    value: function getIconEl(tooltipId) {
      return document.getElementById('disclosure-' + tooltipId);
    }
  }, {
    key: 'renderIcon',
    value: function renderIcon(tooltipId) {
      var _this4 = this;

      var _props = this.props,
          breakpoint = _props.breakpoint,
          disclosure = _props.disclosure,
          tooltip = _props.tooltip;

      if (!disclosure || (0, _ramda.isNil)(disclosure[tooltipId])) {
        return null;
      }

      return _react2.default.createElement(
        'span',
        { id: 'disclosure-' + tooltipId, tabIndex: 0, ref: function ref(el) {
            return _this4[tooltipId] = el;
          },
          className: 'icon-info print-hide margin-left-5',
          role: 'tooltip',
          onKeyDown: function onKeyDown(event) {
            return _accessibility_utility2.default.handleEnterClick(_this4, event, _this4.handleDisclosureIconClick.bind(_this4, event, tooltipId, disclosure, tooltip, breakpoint));
          },
          onClick: function onClick(event) {
            return _this4.handleDisclosureIconClick(event, tooltipId, disclosure, tooltip, breakpoint);
          }
        },
        ' '
      );
    }
  }, {
    key: 'handleDisclosureIconClick',
    value: function handleDisclosureIconClick(event, tooltipId, disclosure, tooltip, breakpoint) {
      var el = this[tooltipId];
      var elHeight = el.offsetHeight;
      var elWidth = el.parentNode.getBoundingClientRect().left;
      var elRect = el.getBoundingClientRect();
      var arrowHeight = 4;
      var docTop = document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;

      var toolTipWidth = void 0,
          toolTipContentWidth = void 0,
          closeTipPosition = void 0,
          toolTipContentScroll = 'hidden';
      if (disclosure[tooltipId][0].length > 200) {
        if (breakpoint > 3) {
          elWidth -= 150;
          toolTipWidth = 570;
          toolTipContentWidth = 530;
          closeTipPosition = 530;
        } else {
          toolTipContentScroll = 'auto';
        }
      }
      var elOffset = {
        top: elRect.top + docTop + arrowHeight + elHeight,
        left: elWidth,
        arrowPosition: elRect.left - elWidth - 3,
        toolTipWidth: toolTipWidth,
        toolTipContentWidth: toolTipContentWidth,
        closeTipPosition: closeTipPosition,
        toolTipContentScroll: toolTipContentScroll
      };

      tooltip.openTooltip(elOffset, disclosure[tooltipId], null, true, event);
    }
  }, {
    key: 'renderPerformanceRating',
    value: function renderPerformanceRating(fundPerformanceRating, index) {

      if ((_collection_utility.CollectionUtility.includes((this.props.visibleData || {}).visibleDataPoints, "SHOW_LONSEC_RATING") || _collection_utility.CollectionUtility.includes((this.props.visibleData || {}).visibleDataPoints, "SHOW_ZENITH_RATING")) && !(0, _functional_utility.isNilOrEmpty)(fundPerformanceRating.ratingValue)) {
        return _react2.default.createElement(
          'div',
          { 'data-testid': 'summary-header-perf-rating',
            className: 'flex-performance-rating-element padding-right-20 ' + (index === 0 ? 'margin-bottom-30' : '') + ' ' + this.props.performanceRatingWidthPercentage },
          _react2.default.createElement(
            'div',
            { className: 'title font-regular tag margin-bottom-6', style: { "z-index": "1" },
              'data-testid': 'summary-header-perf-rating-label' },
            _string_utility2.default.renderFormattedLabel(fundPerformanceRating.title, "pdp-summary-header-perf-rating-label")
          ),
          _react2.default.createElement(
            'div',
            { className: 'margin-all-0 display-flex' },
            _react2.default.createElement(
              'div',
              { 'data-testid': 'summary-header-perf-rating-value', className: "float-left margin-top-3" },
              fundPerformanceRating.ratingValue
            ),
            _react2.default.createElement(
              'div',
              { className: "header-as-of-date-element" },
              this.renderAsOfDate(fundPerformanceRating)
            )
          )
        );
      }
      return _react2.default.createElement(
        'div',
        { 'data-testid': 'summary-header-perf-rating',
          className: 'flex-performance-rating-element padding-right-20 ' + this.props.performanceRatingWidthPercentage },
        _react2.default.createElement(
          'div',
          { className: 'title font-regular tag margin-bottom-6', style: { "z-index": "1" },
            'data-testid': 'summary-header-perf-rating-label' },
          _string_utility2.default.renderFormattedLabel(fundPerformanceRating.title, "pdp-summary-header-perf-rating-label"),
          this.renderIcon(fundPerformanceRating.disclosureId)
        ),
        _react2.default.createElement(
          'div',
          { className: 'margin-all-0 display-flex' },
          _react2.default.createElement(
            'div',
            { className: "float-left" },
            _react2.default.createElement('img', {
              alt: '',
              src: this.props.gaiaRedirectUrl + '/images/' + fundPerformanceRating.imageUrl,
              'data-testid': 'summary-header-perf-rating-image',
              className: "vertical-align-top",
              style: { "maxHeight": "50px", "maxWidth": "132px" } })
          ),
          _react2.default.createElement(
            'div',
            { className: "header-as-of-date-element" },
            this.renderAsOfDate(fundPerformanceRating)
          )
        )
      );
    }
  }, {
    key: 'renderPerformanceRatingAsOfDates',
    value: function renderPerformanceRatingAsOfDates(fundPerformanceRating) {
      return _react2.default.createElement(
        'div',
        { 'data-testid': 'summary-header-perf-rating-container',
          className: 'flex-performance-rating-element ' + this.props.performanceRatingWidthPercentage },
        this.renderAsOfDate(fundPerformanceRating)
      );
    }
  }, {
    key: 'renderAsOfDate',
    value: function renderAsOfDate(fundPerformanceRating) {
      if (!(0, _ramda.isNil)(fundPerformanceRating.effectiveDate)) {
        return _react2.default.createElement(
          'div',
          { className: 'category float-left font-off-white margin-top-10',
            'data-testid': 'summary-header-perf-rating-as-of-date' },
          _string_utility2.default.renderFormattedLabel("As of ", "label-for-as-of", { role: this.props.role }),
          _date_formatter2.default.formatDateForLocale(fundPerformanceRating.effectiveDate)
        );
      } else {
        return _react2.default.createElement(
          'div',
          null,
          '\xA0'
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return (0, _functional_utility.doesFormattingRulesContain)("AWARD_MORNINGSTAR_ALIGNMENT_EMEA", this.props.visibleData, ["formattingRules"]) ? this.renderFundRatings() : _react2.default.createElement(
        'div',
        { className: 'margin-all-0 row' },
        this.renderFundRatings()
      );
    }
  }]);

  return SummaryHeaderPerformanceRatings;
}(_react2.default.Component);

exports.default = SummaryHeaderPerformanceRatings;